import { render, staticRenderFns } from "./DrugNames.vue?vue&type=template&id=9404ab20"
import script from "./DrugNames.vue?vue&type=script&lang=js"
export * from "./DrugNames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports